import React, { useState, useEffect, useRef } from "react";
import { AppStoreApplication, AppStoreGroupApplication } from "@/services/AppStore";
import { RECENT_GRROUP_ID } from "@/components/ThirdApp";

export default function LeftToolsNav ({
  leftNavList,
  onTabChange,
  defaultKey = 0
}: {
  leftNavList: AppStoreGroupApplication[];
  onTabChange: (groupId: string) => void;
  defaultKey?: number;
}) {
  const [activeKey, setActiveKey] = useState<number>(defaultKey);
  return (
    <div className="left-tools-nav">
      {leftNavList?.map((item: AppStoreGroupApplication, index: number) => {
        if (item.groupId === RECENT_GRROUP_ID) {
          return "";
        }
        return (
          <div
            className={
              activeKey === index
                ? "left-tools-nav_item left-tools-nav_item_active"
                : "left-tools-nav_item"
            }
            key={item.groupId}
            onClick={() => {
              onTabChange(item.groupId);
              setActiveKey(index);
            }}
          >
            {item.name}
          </div>
        );
      })}
    </div>
  );
}
